import React from 'react';
import { useTranslation } from 'react-i18next';
import { Tag, TagProps } from 'components/_new/Tag';
import { ApplicationRole, ApplicationRoleEnum } from 'types/Application';

export const MandatoryTag = ({ ...props }: Omit<TagProps, 'children' | 'icon' | 'variant'>) => {
	const { t } = useTranslation();
	return (
		<Tag variant="rose" min icon={{ name: 'triangle-exclamation' }} {...props}>
			{t('timeline.item.mandatory')}
		</Tag>
	);
};

export const RequireConfirmationTag = ({ ...props }: Omit<TagProps, 'children' | 'icon' | 'variant'>) => {
	const { t } = useTranslation();
	return (
		<Tag variant="blue" icon={{ name: 'user-check' }} min {...props}>
			{t('timeline.item.requireConfirmation')}
		</Tag>
	);
};

export const AplicationRoleVisibilityTag = ({
	role,
	...props
}: Omit<TagProps, 'children' | 'icon' | 'variant'> & { role: ApplicationRole }) => {
	const { t } = useTranslation();
	return (
		<Tag variant="blue" icon={{ name: role === 'mentor' ? 'user-tie' : 'user-graduate' }} min {...props}>
			{role === 'mentor' ? t('misc.forMentors') : t('misc.forMentees')}
		</Tag>
	);
};
